import PosthogService from '~/services/posthog/PosthogService';

export interface IEndOfDayTimeAdjustmentPopupViewedPayload {
  shiftId: string;
}

/**
 * Fires when the "Confirm Adjustment" pop-up appears on the end-of-day
 * adjustment page.
 * Event: dental_portal:end_of_day:time_adjustment_popup_viewed
 */
export function fireEndOfDayTimeAdjustmentPopupViewed(
  payload: IEndOfDayTimeAdjustmentPopupViewedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:end_of_day:time_adjustment_popup_viewed', {
    shift_id: payload.shiftId,
  });
}
